import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import arrowToStart from "../../photos/reshot-icon-right-arrow-UCA8NGYZDJ.svg";
import { plannerStore } from "../../App";
const StartUp = (props) => {
  const navigator = useNavigate();
  const [start, setStart] = useState(false);
  const setIsInStart = plannerStore((state) => state.setIsInStart);
  return (
    <div className=" mt-[65%]">
      <div>
        <h1>Welcome to Plan Your Way!</h1>
        <h3>More than your average everyday planner, build it how you want</h3>
        <p>
          Plan your way planners is here to help you customize the planner you
          have been looking for
        </p>

        <button
          onClick={() => {
            navigator("/colorSelection");
            setStart(true);
            setIsInStart(true);
          }}
          className="rounded bg-white p-2 "
        >
          <span className="flex flex-row gap-2 rounded-lg ">
            Get Planning!
            <img src={arrowToStart} alt="start" width={20} height={20} />
          </span>
        </button>
      </div>
    </div>
  );
};
export default StartUp;
